import {
    Component,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EssErrorService, EssSoftwareUpdateService } from 'ngx-essentia';
import { TimePeriod } from 'whocan-lib';

import { environment } from '../environments/environment';
import { NGXLogger as LoggerService } from "ngx-logger";
import { describeRejectionReason } from './shared/helpers/rejection-report';
import { ResponsiveService } from './shared/services/responsive.service';
import { RouteContextService } from './shared/services/route-context.service';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';
import { ContentLanguageHintService } from './shared/services/content-language-hint.service';
import { TranslationGeneralService } from './shared/translation/translation.general.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
    private _isLoading = true;
    constructor(
        public responsiveService: ResponsiveService,
        public routeContextService: RouteContextService,
        private logger: LoggerService,
        public dialog: MatDialog,
        public swUpdate: EssSoftwareUpdateService,
        private googleAnalyticsService: GoogleAnalyticsService,
        private errorService: EssErrorService,
        public trans: TranslationGeneralService,
        private contentLanguageHintService: ContentLanguageHintService,
    ) { }

    async ngOnInit() {
        this.registerUnhandledRejectionHandler();
        this.load()
        this.errorService.init(this.logger, true)
        if (environment.production) {
            this.swUpdate.setTimeTrigger(60 * 5);
        } else {
            this.swUpdate.setTimeTrigger(60);
        }
        this.responsiveService.setBreakpointObserver();
        this.googleAnalyticsService.initializeAndGetConsent();
        this.routeContextService.subscribe();
        this.contentLanguageHintService.subscribe();
        this.logger.warn('Version number', environment.appVersion);
    }

    private async load() {
        this._isLoading = true;
        try {
            await this.trans.loadTransLationFiles()
            TimePeriod.setAllDAyLabel(this.trans.translate('hourOption.allDay'))
            TimePeriod.setOpenEndLabel(this.trans.translate('hourOption.openEnd'))
            this._isLoading = false
            const trans = this.trans.translate('test.translation.success')
            this.logger.log(trans)
        } catch (e) {
            this._isLoading = false
            // a string, so it sits in the first line of the report: without a network it is no
            // finding, with one the visitor saw a page without texts
            this.logger.error('Error loading translation files', ` (locale ${this.trans.locale}, online ${navigator.onLine})`, e)
        }

    }


    get isLoading() {
        return this._isLoading
    }

    /**
     * Registers a global handler for unhandled promise rejections.
     * Without this, Zone.js catches these rejections and logs only a minified
     * stack trace (e.g. "N@polyfills.js:1:21372") with no useful error message.
     * By routing them through ngx-logger, the actual rejection reason and stack
     * are sent to the backend error reporting (Cloud Function /uilogging).
     */
    private registerUnhandledRejectionHandler() {
        window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
            const reason = event.reason;
            if (reason == null) {
                this.logger.error('Unhandled promise rejection (no reason)');
                return;
            }
            const report = describeRejectionReason(reason);
            if (report.additional === undefined) {
                this.logger.error('Unhandled promise rejection: ' + report.message);
            } else {
                this.logger.error('Unhandled promise rejection: ' + report.message, report.additional);
            }
        });
    }

    ngOnDestroy(): void {
        this.routeContextService.unsubscribe();
    }

}
